import { combinedApi as api } from "../combinedApi";
export const addTagTypes = ["SavedSearch"] as const;
const injectedRtkApi = api
  .enhanceEndpoints({
    addTagTypes,
  })
  .injectEndpoints({
    endpoints: (build) => ({
      getSavedSearchById: build.query<
        GetSavedSearchByIdApiResponse,
        GetSavedSearchByIdApiArg
      >({
        query: (queryArg) => ({ url: `/SavedSearch/${queryArg}` }),
        providesTags: ["SavedSearch"],
      }),
      putSavedSearchById: build.mutation<
        PutSavedSearchByIdApiResponse,
        PutSavedSearchByIdApiArg
      >({
        query: (queryArg) => ({
          url: `/SavedSearch/${queryArg.id}`,
          method: "PUT",
          body: queryArg.configurationDto,
        }),
        invalidatesTags: ["SavedSearch"],
      }),
      deleteSavedSearchById: build.mutation<
        DeleteSavedSearchByIdApiResponse,
        DeleteSavedSearchByIdApiArg
      >({
        query: (queryArg) => ({
          url: `/SavedSearch/${queryArg}`,
          method: "DELETE",
        }),
        invalidatesTags: ["SavedSearch"],
      }),
      postSavedSearch: build.mutation<
        PostSavedSearchApiResponse,
        PostSavedSearchApiArg
      >({
        query: (queryArg) => ({
          url: `/SavedSearch`,
          method: "POST",
          body: queryArg,
        }),
        invalidatesTags: ["SavedSearch"],
      }),
    }),
    overrideExisting: false,
  });
export { injectedRtkApi as savedSearchApi };
export type GetSavedSearchByIdApiResponse =
  /** status 200 OK */ DeletableConfigurationDto;
export type GetSavedSearchByIdApiArg = number;
export type PutSavedSearchByIdApiResponse = /** status 200 OK */ void;
export type PutSavedSearchByIdApiArg = {
  id: number;
  configurationDto: ConfigurationDto;
};
export type DeleteSavedSearchByIdApiResponse = unknown;
export type DeleteSavedSearchByIdApiArg = number;
export type PostSavedSearchApiResponse = /** status 201 Created */ number;
export type PostSavedSearchApiArg = ConfigurationDto;
export type DeletableConfigurationDto = {
  id: number;
  category: string;
  name: string;
  value: string;
  isDefault: boolean;
  isDeletable: boolean;
};
export type ProblemDetails = {
  type?: string | null;
  title?: string | null;
  status?: number | null;
  detail?: string | null;
  instance?: string | null;
  [key: string]: any;
};
export type ConfigurationDto = {
  id: number;
  category: string;
  name: string;
  value: string;
  isDefault: boolean;
};
export const {
  useGetSavedSearchByIdQuery,
  useLazyGetSavedSearchByIdQuery,
  usePutSavedSearchByIdMutation,
  useDeleteSavedSearchByIdMutation,
  usePostSavedSearchMutation,
} = injectedRtkApi;
